import ReportOutlinedIcon from "@material-ui/icons/ReportOutlined";
import { ViolationsListView } from "./ViolationsListView";

export default {
  icon: ReportOutlinedIcon,
  list: ViolationsListView,
};
